import { render, staticRenderFns } from "./AuditAppraisal.vue?vue&type=template&id=be63bf38&scoped=true&"
import script from "./AuditAppraisal.vue?vue&type=script&lang=js&"
export * from "./AuditAppraisal.vue?vue&type=script&lang=js&"
import style0 from "./AuditAppraisal.vue?vue&type=style&index=0&id=be63bf38&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be63bf38",
  null
  
)

export default component.exports